<template>
  <div class="share-page my-clue-result">
    <Header :style="{position: 'relative', top:0, width: '100%',minWidth: '1024px'}">
      <!-- 切换按钮 -->
      <div class="logo-large-icon">
        <div class="fl logo-div" @click="goWorkBench">
          <img key="max-logo" :src="imgLogo" />
          <p>安盾管理平台</p>
        </div>
      </div>
    </Header>
    <div style="padding:15px 15px 0px 15px;height:calc(100% - 50px)">
      <div class="share-container">
        <div class="card-style">
          <!-- 批量操作区域 -->
          <Row class="header-common-right-box">
            <Col style="float:left;margin-left:10px;">
              <Checkbox v-model="isCheckedAll" :indeterminate="indeterminate" @on-change="checkAll" />
              <Dropdown @on-click="headerOption">
                <Button style="padding:0 15px">
                  {{ $t('BatchOperation') }}
                  <Icon type="ios-arrow-down" />
                </Button>
                <DropdownMenu slot="list">
                  <DropdownItem :disabled="idList.length==0" name="agree">批量通过</DropdownItem>
                  <DropdownItem :disabled="idList.length==0" name="reject">批量驳回</DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </Col>
            <!-- 筛选项 -->
            <Col class="filter-col search-box">
              <Input
                v-model="searchForm.keyword" placeholder="请输入关键字" style="width: 250px;"
                @on-enter="reloadTable"
              >
                <Icon slot="suffix" type="ios-search" @click="reloadTable" />
              </Input>
              <span :class="['icon-more-01' ,'search-more-icon',{'active':searchBoxCtrl}]" @click="searchBoxCtrl=!searchBoxCtrl"></span>
              <div v-show="searchBoxCtrl" class="container">
                <Row class="header-common-right-box">
                  <Col span="6" class="header-common-col">
                    审核状态
                  </Col>
                  <Col span="18">
                    <Select v-model="searchForm.custState" placeholder="请选择客户审核状态">
                      <Option v-for="item in custStateArr" :key="item.value" :value="item.value">{{ item.nameZh }}</Option>
                    </Select>
                  </Col>
                </Row>
                <Row class="header-common-right-box" style="text-align:right;margin-top:5px;">
                  <Button type="primary" size="small" @click="reloadTable">{{ $t('Confirm') }}</Button>
                  <Button size="small" @click="clearConditions">{{ $t('Clear') }}</Button>
                </Row>
              </div>
            </Col>
          </Row>

          <!-- 表格 -->
          <ul class="list">
            <Spin v-if="tableLoading" fix />
            <li v-for="(item,index) in data" :key="index">
              <div class="result-title">
                <Checkbox :value="idList.indexOf(item.id)>=0?true:false" @on-change="checkOption(item.id)" />
                <span class="result-time">{{ item.submitTime.slice(0,10) }}</span>
                <span class="result-name" @click="getClueDetail(item.id)">
                  <!-- <span class="push-icon" v-if="item.custState">推</span> -->
                  <span class="result-code">[编号：{{ item.code }}]</span>
                </span>
                <span class="result-title-option">
                  <Dropdown v-if="item.custState=='C'" @on-click="listOption(item.id,$event)">
                    <a href="javascript:void(0)">
                      <Icon type="ios-more" size="20" />
                    </a>
                    <DropdownMenu slot="list">
                      <DropdownItem name="agree">{{ $t('Pass') }}</DropdownItem>
                      <DropdownItem name="reject">{{ $t('Reject') }}</DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                </span>
              </div>
              <div class="result-main clearfix">
                <div class="result-main-left">
                  <Row style="line-height:30px;">
                    <Col span="8"><span class="textover result-text" :title="storeName(item)">店铺名称：{{ storeName(item) }}</span></Col>
                    <Col span="8">
                      <Row v-if="item.tortSubject">
                        <span class="textover result-text block-shop-text">
                          销售商：
                          <span>
                            <a
                              v-for="(itemTortSubject,indexTortSubject) in item.tortSubject.split(',')" :key="itemTortSubject" href="javascript:void(0);"
                              @click="getBusinessInfo(itemTortSubject)"
                            >
                              {{ itemTortSubject }}
                              {{ indexTortSubject==item.tortSubject.split(',').length-1?"":"," }}
                            </a>
                          </span>
                        </span>
                        <fold-block
                          v-if="item.tortSubject" :text="item.tortSubject" :allow-click="true"
                          :max-num="0" @clickEvent="getBusinessInfo"
                        />
                      </Row>
                      <Row v-else>
                        <span class="textover result-text">销售商：</span>
                      </Row>
                    </Col>
                    <Col v-if="item.tortType.indexOf('E')!=-1" span="8"><span class="textover result-text" :title="item.clueProduct?item.clueProduct.productUrl:''">侵权链接：<a :href="item.clueProduct?item.clueProduct.productUrl:''" target="_blank">{{ item.clueProduct?item.clueProduct.productUrl:"" }}</a></span></Col>
                    <Col v-if="item.tortType.indexOf('S')!=-1" span="8"><span class="textover result-text" :title="(item.provinceName || '')+(item.cityName || '')+(item.areaName || '')+(item.address || '')">调查地址：{{ item.provinceName || "" }}{{ item.cityName || "" }}{{ item.areaName || "" }}{{ item.address || "" }}</span></Col>
                  </Row>
                  <Row style="line-height:30px;">
                    <Col span="8"><span class="textover result-text" :title="item.clueProduct?item.clueProduct.productName:''">产品名称：{{ item.clueProduct?item.clueProduct.productName:"" }}</span></Col>
                    <Col span="8">
                      <Row v-if="item.manufacturerName">
                        <span class="textover result-text block-shop-text">
                          生产商：
                          <span>
                            <a
                              v-for="(itemManufacture,indexManufacture) in item.manufacturerName.split(',')" :key="itemManufacture" href="javascript:void(0);"
                              @click="getBusinessInfo(itemManufacture)"
                            >
                              {{ itemManufacture }}
                              {{ indexManufacture==item.manufacturerName.split(',').length-1?"":"," }}
                            </a>
                          </span>
                        </span>
                        <fold-block
                          :text="item.manufacturerName" :allow-click="true" :max-num="0"
                          @clickEvent="getBusinessInfo"
                        />
                      </Row>
                      <Row v-else>
                        <span class="textover result-text">生产商：</span>
                      </Row>
                    </Col>
                    <Col span="8">
                      <span class="textover result-text">报备团队：
                        <span v-if="item.teamType=='I'" class="icon-investigation-01" :style="{color:mainColor.globalMainColor}"></span>
                        <span v-if="item.teamType=='L'" class="icon-lawyer-01" :style="{color:mainColor.globalMainColor}"></span>
                        {{ item.reportTeam }}
                      </span>
                    </Col>
                  </Row>
                  <Row style="line-height:30px;">
                    <Col span="8">
                      审核状态：
                      <Tag style="border:0;border-radius:11px;" :color="item.custState=='C'?mainColor.warningColor:(item.custState=='CP'?mainColor.successColor:mainColor.errorColor)">
                        {{ item.custState=='C'?'待审核':(item.custState=='CP'?'审核通过':'审核驳回') }}
                      </Tag>
                    </Col>
                    <!-- <Col span="8" v-if="item.state==='E'||item.state==='R'"><span class="textover">[ 备注信息 ]：{{item.remark}}</span></Col> -->
                    <Col v-if="item.custState&&item.custState=='CP'||item.custState=='CD'" span="8"><span class="textover result-text" :title="item.custNote">[ 审核批注 ]：{{ item.custNote }}</span></Col>
                    <Col span="8"><span class="textover">{{ $t('Remarks') }}：{{ item.remark }}</span></Col>
                  </Row>
                  <Row style="line-height:30px;">
                    <Col span="8">
                      <Row v-if="item.clueMemo">
                        <span class="textover result-text block-shop-text">
                          {{ $t('Note') }}：
                          <span
                            v-if="item.clueMemo.attention=='Y'" class="textover note-wrap"
                            :title="item.clueMemo.memo"
                          >{{ item.clueMemo.memo }}</span>
                          <span
                            v-if="item.clueMemo.attention=='N'" class="textover note-wrap"
                            :title="item.clueMemo.memo"
                          >{{ item.clueMemo.memo }}</span>
                        </span>
                      </Row>
                    </Col>
                  </Row>
                </div>
                <div class="result-main-right">
                  <my-viewer
                    v-if="!tableLoading"
                    :width="80"
                    :height="80"
                    :list-data="item.attachmentList"
                    :clue-id="item.id"
                    :is-sort="true"
                    :max-show-length="3"
                    style="margin-top:5px;"
                  />
                </div>
              </div>
            </li>
          </ul>
          <Row style="margin-top:30px;text-align:center;">
            <Page
              :total="table.totalRecords" show-total

              size="small"
              :current="table.pageNum"
              :page-size-opts="config.pageSizeOpts"
              :page-size="config.pageSize"
              :prev-text="$t('PreviousPage')" :next-text="$t('NextPage')"
              show-sizer
              show-elevator
              @on-change="changePage" @on-page-size-change="changeSize"
            />
          </Row>
        </div>
        <!-- 线索详情 -->
        <Drawer
          v-model="clueDetailCtrl"
          title="线索详情"
          width="800"
          :styles="{padding:'0px'}"
          :mask-style="{background:'rgba(0,0,0,0)'}"
        >
          <div slot="header" class="drawer-title">
            <span>{{ clueDetail.code }}</span>
            <Dropdown v-if="clueDetail.custState=='C'" class="edit-icon" @on-click="listOption(clueDetail.id,$event)">
              <a href="javascript:void(0)">
                <Icon type="ios-more" size="20" />
              </a>
              <DropdownMenu slot="list">
                <DropdownItem name="agree">{{ $t('Pass') }}</DropdownItem>
                <DropdownItem name="reject">{{ $t('Reject') }}</DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
          <clue-info v-if="clueDetailCtrl" :clue-detail="clueDetail" />
          <test-purchase-form v-if="clueDetailCtrl" :clue-detail="clueDetail" />
        </Drawer>

        <!-- 审核操作 -->
        <Modal
          v-model="examineCtrl"
          :title="title"
          :width="450"
          :footer-hide="true"
        >
          <Form ref="formValidate" :model="formValidate" :label-width="80">
            <FormItem
              v-if="rejectCtrl" key="rejectShareRes" label="驳回原因"
              prop="reasonId"
              :rules="[{required: true, type: 'number', message: '驳回原因不能为空', trigger: 'blur'}]"
            >
              <Select
                v-model="formValidate.reasonId" placeholder="请选择驳回原因" label-in-value
                @on-change="getLabel"
              >
                <Option v-for="item in clueRejectReasonArr" :key="item.value" :value="item.id">{{ item.nameZh }}</Option>
              </Select>
            </FormItem>
            <FormItem
              v-if="!rejectCtrl" key="agreeShareRes" label="审核原因"
              prop="reasonId"
              :rules="[{required: true, type: 'number', message: '审核原因不能为空', trigger: 'blur'}]"
            >
              <Select
                v-model="formValidate.reasonId" placeholder="请选择审核原因" label-in-value
                @on-change="getLabel"
              >
                <Option v-for="item in clueAgreeReasonArr" :key="item.value" :value="item.id">{{ item.nameZh }}</Option>
              </Select>
            </FormItem>
            <FormItem
              label="备注" prop="examineRemark"
              :rules="[{required: false, message: '请填写备注', trigger: 'blur'},
                       { max:512,message:'不能超过512个字符',trigger:'blur'}]"
            >
              <Input
                v-model.trim="formValidate.examineRemark" type="textarea" :autosize="{minRows: 3,maxRows: 8}"
                placeholder="请填写备注信息(不超过512个字符)"
              />
            </FormItem>
            <FormItem style="text-align:center;">
              <Button type="primary" @click="examineSubmit('formValidate')">{{ $t('Confirm') }}</Button>
              <Button style="margin-left: 8px" @click="examineCtrl=false;"> {{ $t('cancel') }}</Button>
            </FormItem>
          </Form>
        </Modal>
        <!-- 输入验证码 -->
        <Modal
          v-model="linkCtrl"
          title="请输入提取码"
          :width="350"
          :footer-hide="true"
        >
          <Row>
            <Col>
              <Input v-model.trim="verifyCode" placeholder="请输入提取码" />
            </Col>
            <Col style="text-align:center;margin-top:20px;">
              <Button type="primary" @click="getData">打开链接</Button>
            </Col>
          </Row>
        </Modal>

        <Modal
          v-model="businessModal"
          width="80%"
          class="business-modal"
          :footer-hide="true"
        >
          <div slot="header" style="font-weight:700;font-size:18px">工商信息</div>
          <div style="height:100%">
            <business-information v-if="businessModal" :default-obj="activeObj" />
          </div>
        </Modal>
      </div>
    </div>
  </div>
</template>
<script>
import clueInfo from './../clue/clueInfo'
import testPurchaseForm from './../clue/plugin/testPurchaseForm.vue'
import foldBlock from '@/components/common/foldBlock/foldBlock.vue'
import businessInformation from '@/components/common/businessInformation/businessInformation.vue'
import styles from '@/assets/globalStyle.scss'
export default {
  components: {
    foldBlock,
    clueInfo,
    testPurchaseForm,
    businessInformation
  },
  props: [''],
  data () {
    return {
      imgLogo: require('@/assets/images/logo.png'),
      mainColor: styles,
      single: false,
      searchForm: {
        keyword: '',
        custState: ''
      },
      custStateArr: [],
      searchBoxCtrl: false,
      tableLoading: false,
      table: { // 表格数据接口的相关参数
        pageSize: this.config.pageSize,
        pageNum: 1,
        totalRecords: 1
      },
      data: [],
      clueDetailCtrl: false,
      indeterminate: false,
      isCheckedAll: false,
      pageIdList: [], // 每一页的id选项
      idList: [], // 选中的id列表
      examineCtrl: false,
      batchCtrl: false,
      formValidate: {
        examineRemark: '',
        reasonId: ''
      },
      id: '',
      title: '审核通过',
      rejectCtrl: false,
      clueRejectReasonArr: [],
      clueAgreeReasonArr: [],
      clueDetail: '',
      linkCtrl: true,
      verifyCode: '',
      pendingClueId: '',
      businessModal: false,
      activeObj: ''
    }
  },
  watch: {
    idList(val, oldval) {
      console.log(val)
      this.judgeChecked()
    }
  },
  created() {},
  beforeMount() {
    console.log(111)
    this.getDictionary()
  },
  mounted() {
    // 提取码只放 sessionStorage，不进路由，避免链接被转发时泄露
    const queryCode = this.$route.query.verifyCode
    if (queryCode) {
      sessionStorage.setItem('shareVerifyCode', queryCode)
      const query = Object.assign({}, this.$route.query)
      delete query.verifyCode
      delete query.clueId
      this.$router.replace({ path: '/shareList', query }).catch(() => {})
    }
    const code = sessionStorage.getItem('shareVerifyCode')
    this.pendingClueId = sessionStorage.getItem('sharePendingClueId') || ''
    if (this.pendingClueId) {
      sessionStorage.removeItem('sharePendingClueId')
    }
    if (code) {
      this.verifyCode = code
      this.getData()
    }
  },
  updated() {},
  methods: {
    goWorkBench() {
      const custType = window.localStorage.getItem('custType')
      this.$router.push({ path: custType === 'C' ? '/channel' : '/home' })
    },
    storeName(item) {
      if (item.tortType !== 'E_EC') return item.storeName
      let resultName = ''
      resultName = this.$t('ec_channel.' + item.channelType) + '--' + item.storeName
      // 淘宝 / 陶特 添加掌柜号
      if (['TT', 'TS'].includes(item.channelType) && item.dispenser) {
        resultName += `--${item.dispenser}`
      }
      return resultName
    },
    headerOption(name) {
      this.$refs['formValidate'].resetFields()
      switch (name) {
        case 'agree':
          this.examineCtrl = true
          this.rejectCtrl = false
          this.title = this.$t('Approved')
          this.batchCtrl = true
          break
        case 'reject':
          this.examineCtrl = true
          this.rejectCtrl = true
          this.title = this.$t('Rejected')
          this.batchCtrl = true
          break
      }
    },
    listOption(id, name) {
      this.$refs['formValidate'].resetFields()
      this.id = id
      switch (name) {
        case 'agree':
          this.examineCtrl = true
          this.title = this.$t('Approved')
          this.rejectCtrl = false
          break
        case 'reject':
          this.examineCtrl = true
          this.title = this.$t('Rejected')
          this.rejectCtrl = true
          break
      }
    },
    examineSubmit() {
      let url = '/business/clue/cust/audit'
      const ajaxData = {
        clueIds: [],
        remark: this.formValidate.examineRemark,
        reasonId: this.formValidate.reasonId
      }
      if (this.rejectCtrl) {
        url = '/business/clue/cust/reject'
      }
      if (this.batchCtrl) {
        ajaxData.clueIds = this.idList
      } else {
        ajaxData.clueIds.push(this.id)
      }
      this.$patch(url, ajaxData).then(res => {
        this.examineCtrl = false
        if (res.code === 0) {
          this.$Message.success(this.$t('OperationSuccessful'))
          this.idList = []
          this.reloadTable(false)
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    getClueDetail(id) {
      // 未登录跳转前把提取码和线索 id 存本地，登录后可回到本页并自动打开详情（不写进路由）
      if (this.verifyCode) {
        sessionStorage.setItem('shareVerifyCode', this.verifyCode)
        sessionStorage.setItem('sharePendingClueId', id)
      }
      const url = '/business/clue/view/' + id
      this.$get(url).then(res => {
        if (res.code === 0) {
          this.clueDetail = res.data
          this.clueDetailCtrl = true
          sessionStorage.removeItem('sharePendingClueId')
        }
      })
    },
    getLabel(data) {
      this.formValidate.examineRemark = data.label
    },
    getData() {
      const url = '/business/clues/customer/share/list'
      const ajaxData = {
        verifyCode: this.verifyCode,
        current: this.table.pageNum,
        size: this.table.pageSize
      }
      Object.assign(ajaxData, this.searchForm)
      console.log(ajaxData)
      this.tableLoading = true
      this.$get(url, ajaxData).then(res => {
        console.log(res)
        this.tableLoading = false
        if (res.code === 0 && res.data) {
          this.linkCtrl = false
          this.data = res.data.records
          this.table.totalRecords = res.data.total
          sessionStorage.setItem('shareVerifyCode', this.verifyCode)
          // 查看已经勾选项,默认勾选
          this.pageIdList = this.data.map(item => {
            return item.id
          })
          this.judgeChecked()
          // 登录回跳后只自动打开一次详情，避免翻页重复弹窗
          if (this.pendingClueId) {
            const clueId = this.pendingClueId
            this.pendingClueId = ''
            this.getClueDetail(clueId)
          }
        } else {
          this.$Message.error(res.message || '提取失败')
        }
      })
    },
    changePage(page) {
      this.table.pageNum = page
      this.getData()
    },
    changeSize(size) {
      this.table.pageSize = size
      this.getData()
    },
    // 重载table
    reloadTable(resetPage = true) {
      this.addDrawerCtrl = false
      if (resetPage) this.table.pageNum = 1
      this.getData()
    },
    // 清除条件
    clearConditions() {
      this.searchForm.keyword = ''
      this.searchForm.custState = ''
      this.reloadTable()
    },
    /** ***********全选Begin***************/
    // 选中多选框
    checkOption(id) {
      const idIndex = this.idList.indexOf(id)
      if (idIndex >= 0) { // 如果已经包含就去除
        this.idList.splice(idIndex, 1)
      } else { // 如果没有包含就添加
        this.idList.push(id)
      }
    },
    // 全选
    checkAll() {
      if (this.isCheckedAll) {
        if (this.idList.length > 0) {
          for (var i = 0; i < this.pageIdList.length; i++) {
            for (var j = 0; j < this.idList.length; j++) {
              if (this.pageIdList[i] == this.idList[j]) {
                break
              } else if (this.pageIdList[i] != this.idList[j] && j == this.idList.length - 1) {
                this.idList.push(this.pageIdList[i])
              }
            }
          }
        } else {
          this.pageIdList.forEach((item, index) => {
            this.idList.push(item)
          })
        }
      } else {
        for (var i = 0; i < this.pageIdList.length; i++) {
          for (var j = 0; j < this.idList.length; j++) {
            if (this.pageIdList[i] == this.idList[j]) {
              this.idList.splice(j, 1)
            }
          }
        }
      }
    },
    // 判断是否是全选
    judgeChecked() {
      let count = 0
      for (var i = 0; i < this.pageIdList.length; i++) {
        for (var j = 0; j < this.idList.length; j++) {
          if (this.pageIdList[i] == this.idList[j]) {
            count++
          }
        }
      }
      // console.log(count)
      if (count != 0 && count == this.pageIdList.length) {
        this.isCheckedAll = true
        this.indeterminate = false
      } else if (count != 0 && count < this.pageIdList.length) {
        this.isCheckedAll = false
        this.indeterminate = true
      } else {
        this.isCheckedAll = false
        this.indeterminate = false
      }
    },
    /** ***********全选End***************/
    getBusinessInfo(name) {
      const url = '/base/company/one-company-information'
      const ajaxData = {
        companyName: name
      }
      this.$get(url, ajaxData).then(res => {
        if (res.code === 0) {
          if (!res.data || !res.data.creditCode || !res.data.creditCode.trim()) {
            this.$Message.error('未拉取到该主体的工商信息！')
            return
          }
          this.activeObj = {
            creditCode: res.data.creditCode || '',
            name: res.data.compayName || ''
          }
          this.businessModal = true
        }
      })
    },
    getDictionaryItems(code) {
      const url = '/base/dictionaryItem/open/' + code
      const _this = this
      return new Promise(function(resolve, reject) {
        _this.$get(url).then(res => {
          if (res.code == 0) {
            resolve(res.data)
          } else {
            reject(res)
          }
        })
      })
    },
    // 获取字典数据接口
    async getDictionary() {
      this.custStateArr = await this.getDictionaryItems('clue_cust_audit_state')
      this.clueRejectReasonArr = await this.getDictionaryItems('cust_reject')
      this.clueAgreeReasonArr = await this.getDictionaryItems('cust_agree')
    }
  }
}
</script>
<style scoped lang="scss">
@import "../clue/clue.scss";
@import "./shareList.scss";
</style>



// WEBPACK FOOTER //
// src/view/sharePage/shareList.vue